/** */
export const ADD_ONE_CONTENT_JOB_TO_STORE = 'add one content job to store.';
export const ADD_MANY_CONTENT_JOBS_TO_STORE = 'add multiple content jobs to store.';
export const ADD_CONTENT_JOB_SEARCH_RESULTS_TO_STORE = 'add content job search results to store.';
export const LOAD_CONTENT_JOBS_TO_STORE = 'load up content jobs to store.';
export const REM_ONE_CONTENT_JOB_FROM_STORE = 'remove a content job from the store.';

/** */
export const addOneContentJobToStore = (payload) => ({
  type: ADD_ONE_CONTENT_JOB_TO_STORE,
  payload
});

export const addManyContentJobsToStore = (payload) => ({
  type: ADD_MANY_CONTENT_JOBS_TO_STORE,
  payload
});

export const addContentJobSearchResultsToStore = (payload) => ({
  type: ADD_CONTENT_JOB_SEARCH_RESULTS_TO_STORE,
  payload
});

export const loadContentJobsToStore = (payload) => ({
  type: LOAD_CONTENT_JOBS_TO_STORE,
  payload
});

export const removeOneContentJobFromStore = (payload) => ({
  type: REM_ONE_CONTENT_JOB_FROM_STORE,
  payload
});
